import gql from "graphql-tag";
import PropTypes from "prop-types";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query processingRoles($roleName: String) {
      processingRoles(roleName: $roleName) {
        id: roleName
        roleName
        comment
        accesses {
          id
          objectType
          objectValue
          rangeStart
          rangeEnd
          hasAccess
        }
      }
    }
  `,
  variables: ({ roleName }) => {
    return {
      roleName,
    };
  },
  config: {
    pollInterval: 300000,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    // fetchPolicy: "network-only",
  },
  propTypes: {
    roleName: PropTypes.string,
  },
  dataKey: "processingRoles",
  sort: (items) => sortby(items, (o) => parseInt(o.id, 10)),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/processingRoles.js